import React from "react";
import { PriceBox, IconBox, AnchorLink } from "..";
import reportIcon from "../../../assets/images/report-icon.svg";
import confirmReturn from "../../../assets/images/confirm-return.png";
import { Grid, Stack } from "@mui/material";
import { Title } from "../../atoms";

export const OrderItemListWithActions = ({
  cost,
  onReportClick,
  onConfirmReturn,
  isConfirmReturn,
  quantity,
  text,
  url,
  topText,
  urlTrue
}) => {
  return (
    <div className="order-row-container" style={{padding:'0px',width:'100%'}}>
      <div className="order-item-list" style={{width:'100%'}}>
      <Grid spacing={2} container justifyContent="space-between">
        <Grid item md={9} xs={12}>
        <Grid container spacing={4} direction={"row"}>
          <Grid item xs={6}>
            <div className='priceBoxUrl'>
                <Title text={topText} className="topText" />
                <AnchorLink
                    text={text}
                    url={url}
                    urlTrue={urlTrue}
                    className={"anchor-url"}
                />
            </div>
          </Grid>
          <Grid item xs={3}>
            <PriceBox topText={"Item Value"} bottomText={`\u00A3${cost}`} />

          </Grid>
          <Grid item xs={3}>
          <PriceBox topText={"Quantity"} bottomText={quantity} />
        </Grid>
        </Grid>
        </Grid>
        <Grid item md={3} xs={12}>
        <div className="leftM" id="po-actions">
          {isConfirmReturn && (
            <IconBox
            className={'icon-box noborder'}
              icon={confirmReturn}
              subtitle="Confirm return"
              onClick={onConfirmReturn}
            />
          )}
          <IconBox
            icon={reportIcon}
            subtitle="Report issue"
            onClick={onReportClick}
          />
        </div>
        </Grid>
      </Grid>
      </div>
    </div>
  );
};
